import { Music } from "lucide-react";
import { NavLink } from "react-router-dom";
import { instruments } from "../data/instruments";
import { useI18n } from "../i18n/LocaleContext";
import { useTimbroamState } from "../lib/appState";

export function InstrumentsPage() {
  const { dispatch } = useTimbroamState();
  const { locale, config, t, localize, getInstrumentText } = useI18n();
  const featuredInstrumentIds: string[] = config.featuredInstrumentIds;
  const featuredInstruments = instruments.filter((instrument) => featuredInstrumentIds.includes(instrument.id));

  return (
    <section className="content-page" aria-labelledby="instruments-title">
      <div className="content-page-heading">
        <p className="eyebrow">{t.pages.instrumentsEyebrow}</p>
        <h1 id="instruments-title">{t.pages.instrumentsTitle}</h1>
      </div>
      {locale !== "en" ? (
        <section className="locale-focus-panel" aria-label={`${config.englishName} language page`}>
          <div>
            <p className="eyebrow">
              {config.isOfficialWorldLanguage ? t.pages.officialLanguage : t.pages.localeFocus}
            </p>
            <h2>{config.nativeName}</h2>
            <p>{config.focusDescription}</p>
          </div>
          {featuredInstruments.length > 0 ? (
            <div>
              <p className="eyebrow">{t.pages.connectedInstruments}</p>
              <ul>
                {featuredInstruments.map((instrument) => (
                  <li key={instrument.id}>{instrument.name}</li>
                ))}
              </ul>
            </div>
          ) : null}
        </section>
      ) : null}
      <div className="instrument-list">
        {instruments.map((instrument) => {
          const instrumentText = getInstrumentText(instrument);
          const familyClass = `family-${instrument.classification.family.replace(/[^a-zA-Z]/g, "_").toLowerCase()}`;

          return (
            <article className={`instrument-card ${familyClass}`} key={instrument.id}>
              <div className="card-icon" aria-hidden="true">
                <Music size={22} />
              </div>
              <h2>{instrumentText.name}</h2>
              <p>{instrumentText.shortDescription}</p>
              <dl>
                <div>
                  <dt>{t.pages.origin}</dt>
                  <dd>{instrumentText.origin}</dd>
                </div>
                <div>
                  <dt>{t.pages.family}</dt>
                  <dd>{instrumentText.family}</dd>
                </div>
              </dl>
              <NavLink
                to={localize("/")}
                className="text-button"
                aria-label={`Select ${instrument.name} and open performance page`}
                onClick={() => dispatch({ type: "selectInstrument", instrumentId: instrument.id })}
              >
                {t.pages.openInstrument}
              </NavLink>
            </article>
          );
        })}
      </div>
    </section>
  );
}
